'use client';
import React from 'react';
import styles from './NewDefaultFooter.module.scss';
import FooterLink from '../../FooterLink';
import NewAppStoreButton from '../../NewAppStoreButton';
import { FooterStickyNav } from '../../FooterStickyNav';

import {
  aboutBenzinga,
  AppStore,
  copyrightSection,
  FooterLink as IFooterLink,
  tradingToolsAndEducation,
  socialSites,
  marketResources,
  appStores,
} from '../../NewFooterEntity';

import { NavigationFooterProps } from '../..';
import NewSocialIcon from '../../NewSocialIcon';
import SocialIcon from '../../SocialIcon';
import RingTheBellForm from '../../../RingTheBellForm';
import { AfterCopyrightBar } from '../../AfterCopyrightBar';

export const NewDefaultFooter: React.FC<NavigationFooterProps> = ({
  showAppList = true,
  showFooterLinksTable = true,
  showStickyFooter,
  socialMedia = {},
  afterCopyrightBar,
}) => {
  const year = new Date().getFullYear();

  const renderFooterLinks = (links: IFooterLink[]) =>
    links.map(({ label, url }) => <FooterLink key={label} label={label} url={url} />);

  const socialSitesList =
    Object.keys(socialMedia).length > 0
      ? Object.keys(socialMedia).map((site: string) => {
          const socialSitesProps = {
            ...socialSites[site],
            ...socialMedia[site],
          };

          return <SocialIcon {...socialSitesProps} key={socialSitesProps.name} />;
        })
      : Object.keys(socialSites).map((site: string) => {
          const socialSitesProps = socialSites[site];
          return <NewSocialIcon {...socialSitesProps} key={socialSitesProps.name} />;
        });

  const AppList = Object.values(appStores).map((appStore: AppStore) => (
    <NewAppStoreButton icon={appStore.icon} key={appStore.name} name={appStore.name} storeUrl={appStore.link} />
  ));

  return (
    <>
      <div className={showStickyFooter ? 'footer has-sticky-nav' : 'footer'}>
        <div className="new-footer-top-section">
          {showFooterLinksTable && (
            <div className={`${styles.footerRow} footer-row`}>
              <div className={styles.footerColumn}>
                <div>Connect With Us</div>
                <div className="new-logo-and-socials-wrapper">
                  <div className="new-social-sites-list">{socialSitesList}</div>
                </div>
                {showAppList && <div className="app-store-wrapper">{AppList}</div>}
                <div className="about-bz">About Benzinga</div>
                <ul>{renderFooterLinks(aboutBenzinga)}</ul>
              </div>
              <div className={styles.footerColumn}>
                <div>Market Resources</div>
                <ul>{renderFooterLinks(marketResources)}</ul>
              </div>
              <div className={styles.footerColumn}>
                <div>Trading Tools &amp; Education</div>
                <ul>{renderFooterLinks(tradingToolsAndEducation)}</ul>
              </div>
              <div className={styles.footerColumn}>
                <div>Ring the Bell</div>
                <div className="newsletter-form-container">
                  <div className="newsletter-description">
                    <p>
                      A newsletter built for market enthusiasts by market enthusiasts. Top stories, top movers, and
                      trade ideas delivered to your inbox every weekday before and after the market closes.
                    </p>
                  </div>
                  <RingTheBellForm />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="new-footer-bottom-section footer-bottom-common">
          <div className={styles.footerSection}>
            <ul>{renderFooterLinks(copyrightSection)}</ul>
          </div>
        </div>
        <div className={afterCopyrightBar ? 'copyright-bar copyright-bar--with-privacy' : 'copyright-bar'}>
          &copy; {year} Benzinga | All Rights Reserved
        </div>
        <AfterCopyrightBar>{afterCopyrightBar}</AfterCopyrightBar>
      </div>
      {showStickyFooter && <FooterStickyNav />}
    </>
  );
};

export default NewDefaultFooter;
